
import { CustomerPortalService }           from './customer-portal.service';
import { CustomerPortalSettingsComponent } from './customer-portal.settings.component';

export const CustomerPortalStates: Array<any> = [
  {
    component: CustomerPortalSettingsComponent,
    name     : 'app.customer-portal-settings',
    url      : '/customer-portal-settings',
    resolve  : [
      { token: 'settings', deps: [CustomerPortalService], resolveFn: (customerPortalService: CustomerPortalService) => customerPortalService.getSettings() }
    ]
  }
];
